import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';

import { DbShare } from '~src/types/db';
import {
  loadAdminSecondaryShareKeys,
  LoadAdminSecondaryShareKeysParams,
} from '~src/services/api/shares';
import { QueryKeys } from './queryKeys';

/**
 * Primary-/Secondary Share Keys (Tender Admin Update): admin-scoped
 * equivalent of useSecondaryShareKeys.ts - lists the secondary share keys
 * under a given primary share key via normal admin auth (projectId/
 * tenderId), not the vendor's Share-Key header. Mirrors useTenderSharesList.ts's shape.
 */
export const useAdminSecondaryShareKeys = (
  params: LoadAdminSecondaryShareKeysParams,
  queryConfig: QueryConfig<DbShare[], AxiosError> = {}
) => {
  return useQuery<DbShare[], AxiosError>(
    [
      QueryKeys.adminSecondaryShareKeys,
      params.projectId,
      params.tenderId,
      params.shareKey,
    ],
    () => loadAdminSecondaryShareKeys(params),
    {
      enabled: !!params.projectId && !!params.tenderId && !!params.shareKey,
      refetchOnWindowFocus: false,
      ...queryConfig,
    }
  );
};
